const localDemo = {
  'Demonstration workspace. Orders and payments are disabled.':
    'Espacio de demostración. Los pedidos y los pagos están deshabilitados.',
  'Local demo: use fictional patient details only. No insurance check is performed.':
    'Demostración local: use solo datos de pacientes ficticios. No se realiza ninguna verificación de seguro.',
  'Use example patient': 'Usar paciente de ejemplo',
  'Demo request saved. No insurance check was performed.':
    'Solicitud de demostración guardada. No se realizó ninguna verificación de seguro.',
  'Demo orders cannot be submitted.': 'No se pueden enviar pedidos de demostración.',
};
export default localDemo;
